export default Object.freeze({
  ANALYTICS: 'all',
  TRACKED: 'tracked',
  PDF: 'pdf',
  DOWNLOADS: 'downloads'
})
